import {AbstractControl, ValidationErrors} from '@angular/forms';

export class CustomValidators {
  static integer(control: AbstractControl): ValidationErrors | null {
    if (control.value === null || control.value === undefined || control.value === '') {
      return null;
    }

    const value = Number(control.value);
    return Number.isInteger(value) ? null : {integer: true};
  }

  static isoE164(control: AbstractControl): ValidationErrors | null {
    if (control.value === null || control.value === undefined || control.value === '') {
      return null;
    }

    const isoE164Regex = /^(?:\+[1-9]\d{1,14}|\d{9,15})$/;
    return isoE164Regex.test(control.value) ? null : {isoE164: true};
  }

  static dateOfBirth(control: AbstractControl): ValidationErrors | null {
    if (control.value === null || control.value === undefined || control.value === '') {
      return null;
    }

    const dateRegex = /^\d{2}\.\d{2}\.\d{4}$/;
    if (!dateRegex.test(control.value)) {
      return {dateOfBirth: true};
    }

    const [day, month, year] = control.value.split('.').map(Number);
    const dateOfBirth = new Date(year, month - 1, day);
    if (
      dateOfBirth.getFullYear() !== year ||
      dateOfBirth.getMonth() !== month - 1 ||
      dateOfBirth.getDate() !== day
    ) {
      return {dateOfBirth: true};
    }

    const today = new Date();
    const oldest = new Date(today.getFullYear() - 120, today.getMonth(), today.getDate());

    return dateOfBirth > today || dateOfBirth < oldest ? {dateOfBirth: true} : null;
  }

  static countryCode(control: AbstractControl): ValidationErrors | null {
    if (control.value === null || control.value === undefined || control.value === '') {
      return null;
    }

    const countryCodeRegex = /^[A-Za-z]{2}$/;
    return countryCodeRegex.test(control.value) ? null : {countryCode: true};
  }

  static passwordMatch(group: AbstractControl): ValidationErrors | null {
    const password = group.get('password')?.value;
    const passwordRepeat = group.get('passwordRepeat')?.value;
    return password === passwordRepeat ? null : {passwordMatch: true};
  }

  static phoneRequired(group: AbstractControl): ValidationErrors | null {
    const phone = group.get('phone')?.value;
    const mobile = group.get('mobile')?.value;
    return phone || mobile ? null : {phoneRequired: true};
  }

  static whiteSpace(control: AbstractControl): ValidationErrors | null {
    const value = control.value || '';
    const isOnlyWhitespace = value.trim().length === 0;

    return isOnlyWhitespace ? {whitespace: true} : null;
  }
}
